import { withFormik } from 'formik';
import { resendEmail } from '../../../facades/eagle/user';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import { replaceRichText } from 'src/common/utils/text-replace';

/* eslint-disable no-console */
const withLogin = compose(
  withFormik({
    mapPropsToValues: () => ({
      base: '',
      email: '',
    }),
    handleSubmit: (values, actions) => {
      resendEmail(values)
        .then(() => actions.props.setSubmitted(true))
        .catch(err => {
          actions.setSubmitting(false);
          const errors = err.details.errors;
          switch (err.status) {
            case 401:
              actions.setFieldError('base', errors[0].detail);
          }
        });
    },
  }),
  withProps(props => ({
    formSubmissionMessage: replaceRichText(props.formSubmissionMessage, {
      email: props.values.email
    })
  })),
);
/* eslint-enable no-console */

export default withLogin;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withForgottonPassword.js